import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import React from "react";
import { Can } from "@/components/citadel";
import { AddContactMemberModal } from "@/modals/contacts/add-contact-member-modal";

/** Props Interface */
interface ContactMembersMenuProps {
	contactId: string | null;
	refetch: () => Promise<void> | void;
}

export function ContactMembersMenu({ refetch, contactId }: ContactMembersMenuProps) {
	/** Hooks */
	const { t } = useTranslation();
	const addContactMember = useDisclosure();

	/** Render */
	return (
		<React.Fragment>
			<Can
				action="create"
				subject="ContactMembers"
			>
				<Button
					variant="primary"
					icon={<Icon name="Plus" />}
					onClick={addContactMember.onOpen}
					data-cy="add-contact-member-button"
				>
					{t("contacts.add_member")}
				</Button>
			</Can>
			{addContactMember.isOpen && (
				<AddContactMemberModal
					isOpen={addContactMember.isOpen}
					onClose={addContactMember.onClose}
					contactId={contactId}
					onComplete={refetch}
				/>
			)}
		</React.Fragment>
	);
}
